module.exports = __webpack_public_path__ + "static/media/certn_integration_ss_1.f4a38dc9.jpg";